import script from "./AddMedicineModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMedicineModal.vue?vue&type=script&setup=true&lang=js"

import "./AddMedicineModal.vue?vue&type=style&index=0&id=6817fbe1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6817fbe1"]])

export default __exports__